module.exports = __webpack_public_path__ + "img/T5-A-rc_10.13069934.png";